<template>
    <FloatingPanel>
        <div class="canvas-blocks-custom-photoWithText-BlockPanel">

            <SwitchInput
                label="Toon kleine/grote foto"
                instruction="Kies of je een kleine of grote foto wilt tonen."
                :items="[
                    { value: 'small', label: 'Kleine foto' },
                    { value: 'large', label: 'Grote foto' }
                ]"
                :options="options"
                :defaultValue="small"
                options-property="photoSize"
                :open="true"
            />

            <CommonInputs :options="options" :open="false" />

        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs';
import SwitchInput from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput';

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput
    },

};
</script>
